import { Loader } from "@launchmetrics/lm-ui";
import K2Api from "lib/ajax/K2Api";
import queryString from 'query-string';
import { useEffect } from "react";
import { withRouter } from "react-router";
import { useHistory } from "react-router-dom";

function AuthenticateConnection(props) {
  const queryParams = queryString.parse(props.location.search, { ignoreQueryPrefix: true });
  const history = useHistory();

  useEffect(() => {
    const k2Api = new K2Api();
    async function APIAuthentication() {
      try {
        await k2Api.post(`/session`, {callback_url: window.location.href});
        window.location.href = queryParams.next;
      } catch (err) {
        history.replace('/error/401');
      }
    }
    APIAuthentication();
  }, [queryParams, history]);

  return <Loader />;
}

export default withRouter(AuthenticateConnection);
